<template>
<div class="grid grid-cols-7 gap-6 mt-20">
    <div class="col-span-4 scrolleffect fadeinupeffect">
        <img class="w-full h-auto" :src="publickPath + '/images/staff-1.jpg'">
    </div>
    <div class="col-span-3 flex items-center scrolleffect fadeinupeffect">
        <div>
            <p><span class="inline-block bg-lemon-normal py-1 px-2 font-bold text-sm tracking-wide">南船場店</span></p>
            <h5 class="mt-2"><span class="inline-block bg-lemon-normal px-2 py-1 font-bold text-2xl tracking-wide">店長 / 安井 英樹</span></h5>
            <p class="text-sm font-bold mt-6 leading-6">
                チェントに居て、入って、仕事して良かったこと、嬉しかったことは？
            </p>
            <p class="mt-6 leading-7">
                メンバーやお客様と“出会え、築けた関係性”。メンバーにもお客さまにも愛があり、思いやりや優しさに溢れ、お客さまと販売員を超えた友人のような関わり方ができる会社ですね。
            </p>
        </div>
    </div>
    <div class="col-span-4 scrolleffect fadeinupeffect">
        <img class="w-full h-auto" :src="publickPath + '/images/staff-2.jpg'">
    </div>
    <div class="col-span-3 flex items-center scrolleffect fadeinupeffect">
        <div>
            <p><span class="inline-block bg-lemon-normal py-1 px-2 font-bold text-sm tracking-wide">阪急メンズ大阪店</span></p>
            <h5 class="mt-2"><span class="inline-block bg-lemon-normal px-2 py-1 font-bold text-2xl tracking-wide">店長 / 佐渡川 梨沙</span></h5>
            <p class="text-sm font-bold mt-6 leading-6">
                チェントの何に価値を感じこの場所にいるのですか？
            </p>
            <p class="mt-6 leading-7">
                チェントは“セラピー”。皆さん元気になりに来てくださる。人生を変えてくれるくらいの、“新しい扉”を開くお手伝いを、みんなと一緒にワクワクしながら、お客さまにとっての正解を作っていけることが楽しくて、働いているのだと思います。
            </p>
        </div>
    </div>
    <div class="col-span-4 scrolleffect fadeinupeffect">
        <img class="w-full h-auto" :src="publickPath + '/images/staff-3.jpg'">
    </div>
    <div class="col-span-3 flex items-center scrolleffect fadeinupeffect">
        <div>
            <p><span class="inline-block bg-lemon-normal py-1 px-2 font-bold text-sm tracking-wide">本社</span></p>
            <h5 class="mt-2"><span class="inline-block bg-lemon-normal px-2 py-1 font-bold text-2xl tracking-wide">WEB担当 / 冨本 耕司</span></h5>
            <p class="text-sm font-bold mt-6 leading-6">
                チェントってどんな会社ですか？
            </p>
            <p class="mt-6 leading-7">
                “イキリたい”を叶え、服を通じて“体験”を想像させてくれる場所。 自分らしく仕事を楽しめるかどうかは、自分次第。「こうなりたい」とか「これをやりたい」、その気持ちを考えているだけでなく、口に出して実行していく。それができる会社なんだと思います。
            </p>
        </div>
    </div>
</div>    
</template>

<script>

export default {
  components: {
  },
  computed: {
    publickPath() {
      if (process.env.NODE_ENV === 'production') {
        return '/recruit'
      } else {
        return ''
      }
    }
  }
}
</script>
